import styled from 'styled-components';

const Wrapper = styled.div`
  color: ${p => (p.disabled ? '#999' : '#2196f3')};
  text-decoration: underline;
  cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};
  font-size: 13px;
  outline: none;
  &:hover,
  &:focus {
    color: ${p => (p.disabled ? '#999' : '#007bff')};
  }
`;

/**
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {Function} props.onClick
 * @param {boolean} props.disabled
 * @param {string} props.ariaLabel
 */
const LinkButton = ({ children, onClick, disabled, ariaLabel }) => {
  const handleClick = e => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick();
  };

  return (
    <Wrapper
      tabIndex={0}
      aria-label={ariaLabel}
      onClick={handleClick}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          handleClick(e);
        }
      }}
      disabled={disabled}
      role='button'
    >
      {children}
    </Wrapper>
  );
};

export default LinkButton;
